export const announcements = [
  'Limited-time offer',
  'Today only · 46% off',
  '7 free bonuses',
  'Instant access',
  '7-day guarantee',
]

export const painPoints = [
  "You can't stand those dirty grout lines, outdated tiles, damaged floors, or water stains anymore.",
  'You\'ve been saying "I\'ll fix this someday" for years, but you keep putting it off.',
  'You feel embarrassed when people come over because your home looks old and outdated.',
  'You got a renovation quote and when you saw the price… you decided to leave things as they were.',
  "You don't want to deal with contractors, dust, noise, unexpected costs, and weeks of disruption.",
  "You rent and need solutions that are reversible and won't damage the property.",
]

export const benefits = [
  'Look at your home again and think "Now THIS feels like my home."',
  'Make magazine-worthy changes without turning your house into a construction zone.',
  'Stop thinking "I\'ll fix it someday" and finally know where to start.',
  'Transform more while spending less by making the most of what you already have.',
  'Feel proud to invite people over and show them your home.',
  "Even if you're renting, make your space feel like yours without changing everything.",
]

export const solutions = [
  {
    title: 'Dirty grout & worn-out floors',
    text: 'Discover different ways to refresh and renew your grout without replacing everything.',
    image: 'https://cdn.magicpatterns.com/uploads/bVafFX3A2yZkBRhMFnTdfr/WhatsApp_Image_2026-10-04_at_12.52.27_(4).jpg',
    alt: 'Worn concrete floor being rolled with fresh gray floor paint',
  },
  {
    title: 'Cover outdated tiles',
    text: 'Learn ways to update old tiles without tearing them out — even in areas such as kitchens and bathrooms.',
    image: 'https://cdn.magicpatterns.com/uploads/hdD9wtHZH9WGXGXE11fspo/WhatsApp_Image_2026-10-04_at_12.52.30_(3).jpg',
    alt: 'Old patterned tiles being painted white with a roller',
  },
  {
    title: 'Transform any piece of furniture',
    text: 'Give old furniture a completely new look in a single day.',
    note: 'Without sanding, painting, or making a huge mess.',
    image: 'https://cdn.magicpatterns.com/uploads/ss2kuhV37YRvDivNxs3Aie/WhatsApp_Image_2026-10-04_at_12.52.27.jpg',
    alt: 'Dark wood chest being refreshed with a soft greige finish',
  },
  {
    title: 'Create your own walk-in closet',
    text: 'Turn part of your bedroom into a functional dressing area without needing expensive MDF construction.',
    image: 'https://cdn.magicpatterns.com/uploads/iQzmthJ7DKy5epGePSTSiT/WhatsApp_Image_2026-10-04_at_12.52.27_(1).jpg',
    alt: 'Old wooden dresser restyled in cream with brass pulls',
  },
  {
    title: 'Deal with leaks & moisture',
    text: 'Discover practical solutions for dealing with water stains, leaks, and moisture both inside and outside your home.',
    image: 'https://cdn.magicpatterns.com/uploads/nk2HZVPoTcZr1raEirE77r/WhatsApp_Image_2026-10-04_at_12.52.30_(2).jpg',
    alt: 'Stained beige bathroom tiles updated to clean white marble-look surfaces',
  },
  {
    title: 'Completely refresh your kitchen',
    text: 'Update cabinets, tiles, floors, and other kitchen surfaces without starting a major renovation.',
    image: 'https://cdn.magicpatterns.com/uploads/3inEQth4jtDLZv9U3Me6M1/WhatsApp_Image_2026-10-04_at_12.52.27_(2).jpg',
    alt: 'Wood kitchen cabinets repainted in muted teal with warm under-cabinet lighting',
  },
  {
    title: 'Renew your floor without removing the old one',
    text: 'Discover ways to cover and refresh your existing flooring without tearing it out first.',
    image: 'https://cdn.magicpatterns.com/uploads/9xvCPWms9t7Uz8sC7HrRPq/WhatsApp_Image_2026-10-04_at_12.52.28_(1).jpg',
    alt: 'Wood-look vinyl planks laid directly over old terrazzo tiles',
  },
  {
    title: 'Give your walls a fresh new look',
    text: 'Learn how to transform living room walls, bedrooms, hallways, and more in just one day using affordable techniques and materials.',
    image: 'https://cdn.magicpatterns.com/uploads/ade2iue2xQY17pBiW8f7eF/WhatsApp_Image_2026-10-04_at_12.52.26_(3).jpg',
    alt: 'Woman troweling a sage textured finish onto a living room wall',
  },
  {
    title: 'Add lights, outlets & wall fixtures',
    text: 'Discover ways to add electrical points where you need them',
    note: 'Without tearing open your walls.',
    image: 'https://cdn.magicpatterns.com/uploads/jLoYdrTxmZUDPQLiT2gWsi/WhatsApp_Image_2026-10-04_at_12.52.30.jpg',
    alt: 'Kitchen backsplash with warm under-cabinet LED lighting and adhesive marble panels',
  },
  {
    title: 'A more affordable alternative to MDF',
    text: 'Discover a material that can give you a similar look to MDF — but at a much lower cost.',
    image: 'https://cdn.magicpatterns.com/uploads/9KRyvCUXrPda3FhU9g4dX4/WhatsApp_Image_2026-10-04_at_12.52.26_(4).jpg',
    alt: 'Wood slat accent wall made with adhesive panels behind a TV',
  },
]

export const offerIncludes = [
  '101 practical solutions organized by room and problem',
  'Materials, tools, and preparation instructions',
  'Clear steps, common mistakes, and compatibility tips',
  '9 categories covering floors, walls, kitchens, bathrooms, furniture, and more',
  '7 useful downloadable bonuses',
]

export const bonuses = [
  {
    title: 'The 48H Method',
    subtitle: "50 transformations to do when you don't have time — from 1 hour to 48 hours.",
    price: '$7.99',
    image: 'https://cdn.magicpatterns.com/uploads/jAALsGaSBoezG5bca9ma7K/Gemini_Generated_Image_4b5hb24b5hb24b5h.jpg',
  },
  {
    title: 'Save Your Renovation',
    subtitle: '47 errors that seem irreversible — and what to do when they occur.',
    price: '$8.99',
    image: 'https://cdn.magicpatterns.com/uploads/2sALNehbnTiaY1m9vn8imz/Gemini_Generated_Image_sf5y1ysf5y1ysf5y.jpg',
  },
  {
    title: 'Pinterest Home',
    subtitle: '50 DIY projects that look professional, for a home that looks far more expensive.',
    price: '$9.99',
    image: 'https://cdn.magicpatterns.com/uploads/4qhGz39g5ZGATaGveSL32h/Gemini_Generated_Image_ghwc18ghwc18ghwc.jpg',
  },
  {
    title: 'Rented Home',
    subtitle: 'Renovate without irreversible changes, with budget-friendly ideas for every room.',
    price: '$6.99',
    image: 'https://cdn.magicpatterns.com/uploads/5D1psvHevqyjmQKGVvr219/Gemini_Generated_Image_maigqmaigqmaigqm.jpg',
  },
  {
    title: 'Plants That Transform Your Home',
    subtitle: 'Ideas and care for real environments, room by room.',
    price: '$7.99',
    image: 'https://cdn.magicpatterns.com/uploads/iD7DePwgY7iojQ1KRurJYA/Gemini_Generated_Image_n3l299n3l299n3l2.jpg',
  },
  {
    title: "The Kids' Room",
    subtitle: 'Functional and cute ideas that grow with them.',
    price: '$8.99',
    image: 'https://cdn.magicpatterns.com/uploads/arbDdhKcJty3tQXrCp71rB/Gemini_Generated_Image_m6tkykm6tkykm6tk.jpg',
  },
  {
    title: 'A Home Office in a Corner',
    subtitle: 'Create a comfortable workspace even if you have little floor space.',
    price: '$7.99',
    image: 'https://cdn.magicpatterns.com/uploads/wJt7aPWZMngxyg5KPy8Vpk/Gemini_Generated_Image_3omkpm3omkpm3omk.jpg',
  },
]

export const testimonials = [
  {
    name: 'Megan Carter',
    quote: 'I wanted to refresh my tiny laundry room and assumed I would have to tear everything out. The guide helped me compare my options — a new backsplash and a wood counter made all the difference.',
    photo: 'https://cdn.magicpatterns.com/uploads/fYmA3txAhMyBWvyjVBzDqa/WhatsApp_Image_2026-10-04_at_12.52.24_(3).jpg',
    photoAlt: "Megan's refreshed laundry corner with a patterned backsplash, wood counter, and open shelves",
    avatar: 'https://cdn.magicpatterns.com/uploads/hChFbfq73ZaBkFtK4vmMcX/WhatsApp_Image_2026-10-04_at_12.52.29_(1).jpg',
  },
  {
    name: 'Jennifer Walsh',
    quote: "I rent, so I don't like investing in things I won't be able to take with me later. The section about reversible solutions gave me ideas I actually used in my bathroom.",
    photo: 'https://cdn.magicpatterns.com/uploads/fCvogUKGW853apFf9fzQha/WhatsApp_Image_2026-10-04_at_12.52.24_(1).jpg',
    photoAlt: "Jennifer's small bathroom with an over-toilet shelf, woven baskets, and warm sconces",
    avatar: 'https://cdn.magicpatterns.com/uploads/hYevUKJSFHtnF4U6mwbacf/WhatsApp_Image_2026-10-04_at_12.52.28_(3).jpg',
  },
  {
    name: 'Linda Thompson',
    quote: 'I have absolutely no renovation experience. That damp corner had bothered me for years — the guide explained what causes it and which mistakes to avoid before painting.',
    photo: 'https://cdn.magicpatterns.com/uploads/wgW5tnydvQ7DJp2esTzP3C/WhatsApp_Image_2026-10-04_at_12.52.24.jpg',
    photoAlt: "Linda's wall corner before and after: mold stains removed and repainted clean white",
    avatar: 'https://cdn.magicpatterns.com/uploads/1idvgk7CVoTARW6C5ktFo4/WhatsApp_Image_2026-10-04_at_12.52.28_(4).jpg',
  },
  {
    name: 'Ashley Brooks',
    quote: 'The planner helped me separate what was urgent from what could wait. I ended up with a much clearer shopping list — and a bedroom that finally feels cozy.',
    photo: 'https://cdn.magicpatterns.com/uploads/x3XVMD7BFB14WPakN5jWLk/WhatsApp_Image_2026-10-04_at_12.52.23.jpg',
    photoAlt: "Ashley's cozy bedroom with a lit floating shelf, plants, and warm string lights",
    avatar: 'https://cdn.magicpatterns.com/uploads/qk689zY738LgLXF8vs2uoh/WhatsApp_Image_2026-10-04_at_12.52.28_(2).jpg',
  },
]

export const faqs = [
  { q: 'I know absolutely nothing about home renovations. Is this still for me?', a: "Absolutely. The content is designed primarily for beginners. Each solution explains what you'll need, how to prepare the surface, what steps to follow, and which mistakes to avoid." },
  { q: 'Do I have to complete all 101 solutions?', a: "Not at all. Think of it as a reference library. Go directly to the room or problem you're trying to solve and come back to the rest whenever you need it." },
  { q: 'Do I need professional tools?', a: "Not for many of the solutions. Each guide tells you which materials and tools are required before you begin, so you'll know exactly what you'll need." },
  { q: 'What if I buy the wrong material?', a: "That's exactly why the content includes compatibility information, situations where an alternative may or may not be appropriate, and a complementary materials guide." },
  { q: 'Is the content suitable for my country?', a: 'The principles and techniques can be applied broadly, but the availability and names of specific products may vary depending on your country, region, and local stores.' },
  { q: 'Does it work if I rent?', a: "Yes. There's a dedicated section and bonus focused on reversible or low-impact solutions. However, you should always check your lease agreement before making modifications to a rental property." },
  { q: 'Can I really do these projects myself?', a: 'Many of the solutions are designed for DIY beginners. However, situations involving electricity, gas, structural issues, serious moisture problems, or other technical risks should always be handled by a qualified professional.' },
  { q: 'Are these videos?', a: 'No. Everything is digital and provided in PDF format, so you can download it and read it from your phone, tablet, or computer whenever you need it.' },
  { q: 'Is this just an ebook?', a: "No. It's designed as a digital library containing 101 solutions, guides, materials references, checklists, visual ideas, and planning worksheets." },
  { q: 'When will I receive access?', a: 'Access is digital and delivered immediately after your payment is confirmed. You can access and download your files from your devices.' },
  { q: "What if it's not what I expected?", a: 'You have a 7-day guarantee, subject to the conditions provided at the time of purchase.' },
]

export const withoutGuide = [
  'You spend hours searching through random tutorials.',
  "You buy materials without knowing whether they'll work.",
  'You assume everything needs to be replaced.',
  "You don't know where to begin.",
]

export const withGuide = [
  'You have an organized library based on problems and rooms.',
  'You can check compatibility and preparation before starting.',
  'You can explore ways to refresh what you already have.',
  'You choose a solution and follow a clear step-by-step process.',
]
